module.exports = __webpack_public_path__ + "static/img/E.2ec72f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/E.png
// module id = XAmA
// module chunks = 0